import { render, staticRenderFns } from "./OrderProductPopup.vue?vue&type=template&id=5c44bd7e&"
import script from "./OrderProductPopup.vue?vue&type=script&lang=js&"
export * from "./OrderProductPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports